export enum ThemeEnum {
  Dark = 'dark',
  Light = 'light',
  Themed = 'themed', // deprecated
}
